import type { MissedDeadlineDto, CreateAttestationRequest } from '@signalvote/shared';
import { apiJson, apiVoid } from './apiFetch';
import { campaignHeaders, defineQuery, defineWrite } from '../../lib/data';
import { refusal } from './useFinanceContributions';


const missedDeadlinesRead = defineQuery({
  key: () => ['finance', 'committee-formation', 'missed-deadlines'],
  reads: 'GET /api/finance/committee-formation/missed-deadlines',
  fetch: (_: undefined, { signal, campaignId }) =>
    apiJson<MissedDeadlineDto[]>('/api/finance/committee-formation/missed-deadlines', {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch missed deadlines',
    }),
});

export function useMissedDeadlines() {
  return missedDeadlinesRead(undefined);
}

/** Its write set names the attestation, which refreshes the missed deadlines and the close hub. */
export const useCreateAttestation = defineWrite({
  send: (data: CreateAttestationRequest) =>
    apiVoid('/api/finance/committee-formation/attestations', {
      method: 'POST',
      json: data,
      error: refusal('Failed to create attestation'),
    }),
});
